var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.799805,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F4F7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1245_11579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4502 17.8125H36.6377V15.9375C36.6377 15.6889 36.5389 15.4504 36.3631 15.2746C36.1873 15.0988 35.9488 15 35.7002 15H18.8252C18.5766 15 18.3381 15.0988 18.1623 15.2746C17.9865 15.4504 17.8877 15.6889 17.8877 15.9375V17.8125H15.0752C14.5779 17.8125 14.101 18.01 13.7494 18.3617C13.3977 18.7133 13.2002 19.1902 13.2002 19.6875V21.5625C13.2002 22.8057 13.6941 23.998 14.5731 24.8771C15.0084 25.3123 15.5252 25.6576 16.0939 25.8932C16.6626 26.1288 17.2721 26.25 17.8877 26.25H18.3154C18.8677 28.0001 19.9206 29.55 21.3441 30.7082C22.7677 31.8664 24.4994 32.5821 26.3252 32.7668V35.625H23.5127C23.2641 35.625 23.0256 35.7238 22.8498 35.8996C22.674 36.0754 22.5752 36.3139 22.5752 36.5625C22.5752 36.8111 22.674 37.0496 22.8498 37.2254C23.0256 37.4012 23.2641 37.5 23.5127 37.5H31.0127C31.2613 37.5 31.4998 37.4012 31.6756 37.2254C31.8514 37.0496 31.9502 36.8111 31.9502 36.5625C31.9502 36.3139 31.8514 36.0754 31.6756 35.8996C31.4998 35.7238 31.2613 35.625 31.0127 35.625H28.2002V32.7633C31.9432 32.3848 35.0486 29.7586 36.1783 26.25H36.6377C37.8809 26.25 39.0732 25.7561 39.9523 24.8771C40.8313 23.998 41.3252 22.8057 41.3252 21.5625V19.6875C41.3252 19.1902 41.1277 18.7133 40.776 18.3617C40.4244 18.01 39.9475 17.8125 39.4502 17.8125ZM17.8877 24.375C17.1418 24.375 16.4264 24.0787 15.899 23.5512C15.3715 23.0238 15.0752 22.3084 15.0752 21.5625V19.6875H17.8877V23.4375C17.8877 23.75 17.9029 24.0625 17.9334 24.375H17.8877ZM34.7627 23.332C34.7627 27.4945 31.3643 30.907 27.2627 30.9375C25.2736 30.9375 23.3659 30.1473 21.9594 28.7408C20.5529 27.3343 19.7627 25.4266 19.7627 23.4375V16.875H34.7627V23.332ZM39.4502 21.5625C39.4502 22.3084 39.1539 23.0238 38.6264 23.5512C38.099 24.0787 37.3836 24.375 36.6377 24.375H36.5791C36.6176 24.0287 36.6371 23.6805 36.6377 23.332V19.6875H39.4502V21.5625Z",
    fill: "#0066CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1245_11579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(11.7998 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateIcon);
export default __webpack_public_path__ + "static/media/rateIcon.069977619513824b005076ff86e9b0cb.svg";
export { ForwardRef as ReactComponent };